import http, { apiErrorMessage } from '../../http';

const vRutaAutorizar = 'autorizar/';

// ─── Intentos de entrega (todos los usuarios) ────────────────────────────────

// Listado de intentos de entrega de un dia (pestana principal del modulo).
// fecha YYYY-MM-DD (el API asume hoy si no se manda), guia opcional; sucursal solo
// la usa matriz (a los demas el API les impone la sucursal del JWT).
export const getIntentosForTable = (fecha, guia, sucursal) => {
    return (dispatch, getState) => {
        let params = {};
        if (fecha) { params.fecha = fecha; }
        if (guia) { params.guia = guia; }
        if (sucursal) { params.sucursal = sucursal; }
        http.get(vRutaAutorizar + 'intentos', { params })
            .then(function (response) {
                // Envelope v1 dataTable: {data:{rows:[...]}} -> la vista espera {data:[...]}
                dispatch({
                    type: "AUTORIZAR_INTENTOS_SUCCESS", payload: {
                        data: { data: response.data.data.rows },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

// Detalle de un intento de entrega (misma fila del listado; fotos = total para la galeria).
export const getIntentoDetalle = (id) => {
    return (dispatch, getState) => {
        http.get(vRutaAutorizar + 'intentos/' + id)
            .then(function (response) {
                // Envelope v1: {data:{intento:{id,guia,numero,maximo,...,fotos}}} -> la vista lee .resultado
                dispatch({
                    type: "AUTORIZAR_INTENTO_SUCCESS", payload: {
                        data: { resultado: response.data.data.intento },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const limpiarIntento = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_LIMPIAR_INTENTO" });
    }
}

// ─── Solicitudes de devolucion (historico de la app vieja) ───────────────────
// Solo se conserva el DETALLE, que abre matriz desde la consulta de guia. El listado
// (GET solicitudes) y resolver (POST .../resolver) siguen en el API pero el dashboard
// ya no los usa: logistica no autoriza ni rechaza devoluciones.

// Detalle completo de una solicitud (snapshot de la entrega original incluido).
export const getSolicitudDetalle = (id) => {
    return (dispatch, getState) => {
        http.get(vRutaAutorizar + 'solicitudes/' + id)
            .then(function (response) {
                // Envelope v1 ANIDADO: {data:{solicitud:{id,guia,tipo,...,fotos_nuevas,anterior:{fecha,recibe,
                // relacion_recibe,motivo_sin_firma,lat,lon,observaciones,fotos,tiene_firma}},
                // guia:{...}, reparto:{...}, puede_autorizar:bool, motivo_bloqueo:string|null}}
                // -> se aplana al shape PLANO que lee la vista (campos ant_* + fotos_anteriores, etc.;
                //    'tipo' REVERSION|DIRECTA viene dentro de solicitud y queda en el plano via el spread)
                const d = response.data.data;
                const s = d.solicitud || {};
                const ant = s.anterior || {};
                const detalle = {
                    ...s,
                    ant_fecha: ant.fecha,
                    ant_recibe: ant.recibe,
                    ant_relacion_recibe: ant.relacion_recibe,
                    ant_motivo_sin_firma: ant.motivo_sin_firma,
                    ant_lat: ant.lat,
                    ant_lon: ant.lon,
                    ant_observaciones: ant.observaciones,
                    fotos_anteriores: ant.fotos,
                    tiene_firma_anterior: ant.tiene_firma,
                    puede_autorizar: d.puede_autorizar,
                    motivo_bloqueo: d.motivo_bloqueo,
                };
                dispatch({
                    type: "AUTORIZAR_DETALLE_SUCCESS", payload: {
                        data: { resultado: detalle },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

// Consulta integral de una guia: maestra + entregas EAD + seguimiento + intentos + solicitudes.
export const consultarGuia = (guia) => {
    return (dispatch, getState) => {
        http.get(vRutaAutorizar + 'guias/' + encodeURIComponent(guia))
            .then(function (response) {
                // Envelope v1: {data:{guia,entregas,seguimiento,intentos,solicitudes}} -> la vista lee .resultado
                dispatch({
                    type: "AUTORIZAR_GUIA_SUCCESS", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const limpiarDetalle = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_LIMPIAR_DETALLE" });
    }
}

export const limpiarGuia = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_LIMPIAR_GUIA" });
    }
}

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_CLOSE_MESSAGES" });
    }
}
